import { createContext, useContext } from 'react';
export var PopupDatePickerContext = /*#__PURE__*/createContext(undefined);
export function usePopupDatePickerContext() {
  var context = useContext(PopupDatePickerContext);

  if (context === undefined) {
    throw new Error('usePopupDatePickerContext should be inside of PopupDatePickerContext.Provider');
  }

  return context;
}
PopupDatePickerContext.displayName = 'PopupDatePickerContext';